























import { Component, Vue } from "vue-property-decorator";
import CourseForm from "@/components/courses/CourseForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import {
  Course as ICourse,
  CourseInfoEdit as ICourseInfoEdit
} from "@/api-v2/course/models";
import CourseFormV2 from "@/components/courses/CourseV2/CourseFormV2.vue";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import { courseApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CustomButton from "@/components/form/CustomButton.vue";
import CourseInfoForm from "@/components/courses/CourseV2/CourseInfoForm.vue";
import { cloneDeep } from "lodash";

@Component({
  components: {
    CourseInfoForm,
    CustomButton,
    CPageButtons,
    CourseFormV2,
    CField,
    CBlock,
    CPage,
    CBreadCrumbs,
    CourseForm
  }
})
export default class CourseDocumentInfoCreate extends Vue {
  course!: ICourse;
  isLoading: boolean = false;
  documentForm: ICourseInfoEdit = {
    hours: 0,
    price: 0
  };
  data() {
    return {
      course: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "courses" },
        label: this.$tc(this.$translate.Courses)
      },
      {
        to: { name: "course", params: { id: this.course.id } },
        label: this.course.title
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  async submit() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    this.isLoading = true;
    let form = cloneDeep(this.documentForm);

    if (form.price) {
      form.price = this.$converter.setPrice(form.price);
    }
    courseApi.CourseInfo.editCourseInfo(this.$route.params.id, form)
      .then(() => {
        this.$router.push({
          name: "courseDocumentInfoCreate",
          params: {
            id: this.$route.params.id
          }
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  created() {
    this.isLoading = true;
    courseApi.Course.getCourse(this.$route.params.id)
      .then(res => {
        this.course = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
